import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqs[0]?.id ?? "");

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-site mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于评论、关注和私信，你可能想问"
          desc="互动相关的规则和设置都整理在这里。没找到答案的内容，可以直接在评论区提问，或者私信社区管理员。"
        />

        <div className="mt-9 flex flex-col lg:flex-row gap-5">
          <div className="flex-1 rounded-lg border border-background-200 bg-background-100 overflow-hidden divide-y divide-background-200">
            {faqs.map((item) => {
              const open = openId === item.id;
              return (
                <div key={item.id}>
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? "" : item.id)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left"
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                        open
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {open && (
                    <div className="px-4 md:px-5 pb-5 -mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <aside className="lg:w-[320px] shrink-0 rounded-lg border border-background-200 bg-secondary-50 p-5">
            <h3 className="font-heading text-base font-bold text-foreground-950">
              还是没解决问题？
            </h3>
            <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
              社区小助手在工作时间会查看评论区和私信信箱，涉及隐私或紧急下线的内容会优先处理。
            </p>
            <div className="mt-5 space-y-3">
              <a
                href="#comments"
                className="flex items-center gap-2.5 text-sm text-foreground-900 hover:text-primary-700 transition-colors"
              >
                <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-chat-3-line"></i>
                </span>
                去评论区提问
              </a>
              <a
                href="#follow"
                className="flex items-center gap-2.5 text-sm text-foreground-900 hover:text-primary-700 transition-colors"
              >
                <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-mail-send-line"></i>
                </span>
                私信社区小助手
              </a>
              <a
                href="#rules"
                className="flex items-center gap-2.5 text-sm text-foreground-900 hover:text-primary-700 transition-colors"
              >
                <span className="w-4 h-4 flex items-center justify-center text-primary-600">
                  <i className="ri-shield-check-line"></i>
                </span>
                查看完整社区规范
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}